import Tag from 'src/components/primitives/Tag/Tag';
import PresetTag from 'src/components/Tags/PresetTag';

interface Props {
	newTag?: boolean;
	hotTag?: boolean;
	tagLabel?: string;
}

export default function NavItemTags({ newTag, hotTag, tagLabel }: Props) {
	if (!newTag && !hotTag && !tagLabel) {
		return null;
	}

	return (
		<>
			{newTag && <PresetTag preset="new" />}
			{hotTag && <Tag className="bg-star-yellow text-black">Hot</Tag>}
			{tagLabel && <Tag variant="neutral">{tagLabel}</Tag>}
		</>
	);
}
